import styled from 'styled-components';

import { Button, Message } from '@design-system-coopeuch/web';

export const StyledWrapperAccordion = styled.section`
  background: yellow;
  & .AccordionItem--header {
    padding: 20px 32px;
    & .AccordionItem--collapsed-indicator > img {
      width: 14px;
    }
  }
  & .AccordionItem--content {
    padding: 0;
  }
  & .AccordionItem--title {
    font-size: 18px;
    line-height: 24px;
  }
  & .AccordionItem--subtitle {
    font-size: 14px;
    line-height: 16px;
    font-weight: 400;
    margin-top: 8px;
  }
  & .AccordionItem--subtitle:empty {
    margin-top: 0px;
  }
`;

export const StyledWrapperCards = styled.div`
  /* TODO: Estilos que se repiten en otro wrapper, ver si se mueven a un style global */
  display: grid;
  grid-row-gap: 16px;
  @media screen and (min-width: 768px) {
    grid-row-gap: 32px;
  }

  && .CardBase--shaded {
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.14);
  }
  && .CardBase_content--no-padding > div {
    padding-right: 16px;
    padding-left: 16px;
    @media screen and (min-width: 768px) {
      padding-right: 32px;
      padding-left: 32px;
    }
  }
  & .CardBase > header {
    padding: 16px 16px;
    @media screen and (min-width: 768px) {
      padding: 20px 32px;
    }
  }
  & .CardBase--titles {
    row-gap: 4px;
  }
  & .CardBase--titles > h2 {
    font-size: 18px;
    line-height: 24px;
    font-weight: 500;
    @media screen and (min-width: 768px) {
      font-size: 24px;
      line-height: 30px;
    }
  }
  & .CardBase--titles > h4 {
    font-size: 14px;
    line-height: 20px;
  }
  & .CardBase p {
    font-size: 14px;
  }
  & .CardBase .title-content {
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
  }
  & .CardBase .subtitle-content {
    font-size: 14px;
    line-height: 20px;
  }
  & .CardBase .text-content {
    font-size: 14px;
    line-height: 22px;
  }
  /* TODO: Fin estilos repetidos */
`;

export const StyledButton = styled(Button)`
  justify-content: start;
  padding: 0px;

  & > span {
    font-size: 16px;
  }
`;

export const StyledMessage = styled(Message)`
  & > div:nth-child(1) > div {
    display: flex;
    flex-direction: column;
    @media screen and (min-width: 768px) {
      flex-direction: row;
      align-items: center;
      & > p {
        margin-left: 0.5rem;
      }
    }
    & > div {
      font-weight: bold;
    }
  }
`;

export const StyledGridWrapper = styled.div`
  display: grid;
  grid-row-gap: 16px;
  & .CardBase header {
    padding: 16px 18px;
  }
  & .CardBase--titles span {
    font-size: 18px;
    font-weight: bold;
  }
`;

export const StyledWrapperProgressBarPassword = styled.article.attrs(() => ({
  className: 'mt-1',
}))`
  display: flex;
  align-items: center;
  margin-left: 8px;
  flex: 1 0 auto;
  && > div > div {
    margin: 0px;
  }
  & > div > div:nth-child(2) {
    height: 5px;
    & > div {
      background-color: ${(props) => (props.progressColor ? `${props.progressColor}` : '#0e891a')} !important;
    }
  }
  & [data-progress='0'] {
    min-width: 0px !important;
  }
  & .text-name-step {
    color: #0e891a !important;
    font-size: 14px;
  }
`;
